/* @flow */
import * as React from 'react';

import SmartTable from 'components/SmartTable';
import OrganizationClassesTableContainer from 'organizations/containers/OrganizationClassesTableContainer';

const nameSorts = [
  { key: 'name_asc', name: 'Ascending' },
  { key: 'name_desc', name: 'Descending' },
];

const createdAtSorts = [
  { key: 'created_at_asc', name: 'Ascending' },
  { key: 'created_at_desc', name: 'Descending' },
];

const COLUMNS = [
  { key: 'name', name: 'Name', sorts: nameSorts },
  { key: 'owner', name: 'Owner' },
  { key: 'message_count', name: 'Announcements' },
  { key: 'participant_count', name: 'Participants' },
  { key: 'created_at', name: 'Date created', sorts: createdAtSorts },
];

const INITIAL_SORT = 'created_at_desc';

type Props = {
  orgId: number,
};

export default function AdminClassesTable({ orgId }: Props) {
  return (
    <SmartTable
      columns={COLUMNS}
      initialSort={INITIAL_SORT}
      namespace={`admin-class-list-${orgId}`}
      searchPlaceholder="Search classes"
      withSearch
      className="AdminClassesTable"
      data-test="smart-table">
      {({ query, sort }) => (
        <OrganizationClassesTableContainer
          organizationId={Number(orgId)}
          query={query}
          sort={sort}
        />
      )}
    </SmartTable>
  );
}
